module.exports = __webpack_public_path__ + "img/sinBarrreras243.aa18e7fb.jpg";